import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Stack, Text } from '@chakra-ui/react';
import { FsmColors } from 'chakra-ui/fsmTheme';

export default function Card({
  title = null,
  clientFacing = false,
  children = null,
  addOnClick = null,
  addOpen = null,
  buttonText = null,
}) {
  return (
    <Stack
      padding={clientFacing ? 0 : '1rem'}
      color={FsmColors.black}
      borderRadius={5}
      borderWidth={clientFacing ? 0 : 1}
      minH={120}
    >
      <Flex justifyContent={buttonText === null ? 'space-between' : 'center'} pb={1}>
        <Flex alignItems="center">
          {title && (
            <Text fontSize={20} fontWeight="bold">
              {title}
            </Text>
          )}
          {!clientFacing && (
            <Flex>
              {addOnClick && !buttonText ? (
                <IconButton
                  aria-label="Add"
                  icon={addOpen ? <MinusIcon /> : <AddIcon />}
                  ml={2}
                  onClick={addOnClick}
                  size="sm"
                  variant="outline"
                />
              ) : null}
            </Flex>
          )}
        </Flex>
      </Flex>
      {children}
    </Stack>
  );
}
